// extracted by mini-css-extract-plugin
module.exports = {"header":"Co2CodeModal_header__FY_5g","input":"Co2CodeModal_input__qtJw9","errorMessage":"Co2CodeModal_errorMessage__LO5_2"};